export { default } from './reducer'



// WEBPACK FOOTER //
// ./src/modules/state/index.js